import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { ROLE } from '@app/constant/RoleConstant'
import { InertiaLink } from '@inertiajs/inertia-react'
import EditIcon from '@mui/icons-material/Edit'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'

export default function UserIndex({ users }) {
  const { t } = useTranslation()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'role',
              Header: t('USER.ROLE'),
              accessor: ({ role }) => t(`USER.${role.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: ROLE.ADMIN, name: t('USER.ADMIN') },
                { value: ROLE.PARTNER, name: t('USER.PARTNER') },
                { value: ROLE.MERCHANT, name: t('USER.MERCHANT') },
              ],
            },
            {
              id: 'email',
              Header: t('USER.EMAIL'),
              accessor: 'email',
              type: 'string',
            },
            {
              id: 'name',
              Header: t('USER.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'phone',
              Header: t('USER.PHONE'),
              accessor: 'phone',
              type: 'string',
            },
            {
              id: 'actions',
              Header: t('USER.ACTIONS'),
              align: 'center',
              cell: {
                style: { whiteSpace: 'nowrap' },
              },
              disableFilters: true,
              Cell: ({ row }) => (
                <IconButton component={InertiaLink} href={route('admin.users.edit', row.original.id)}>
                  <EditIcon />
                </IconButton>
              ),
            },
          ]}
          data={users}
          enableCollapseFilter={false}
          routeName="admin.users.index"
        />
      </Grid>
    </Grid>
  )
}
